import { Alert } from '@material-ui/lab';
import { Theme, withStyles } from '@material-ui/core/styles';

export const StyledAlert = withStyles((theme: Theme) => ({
  root: {
    borderRadius: 2,
    padding: 16,
    boxSizing: 'border-box',
  },
  outlinedInfo: {
    ...theme.palette.alert?.outlinedInfo,
  },
  outlinedError: {
    ...theme.palette.alert?.outlinedError,
  },
  outlinedSuccess: {
    ...theme.palette.alert?.outlinedSuccess,
  },
  message: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 16,
    lineHeight: '24px',
    color: theme.palette.text.primary,
    padding: 0,
  },
}))(Alert);
